import React from 'react';

const Portal = ({color = '#1976d2', width = 20, height = 20}) => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 100 100" width={width}
             height={height}>
            <path
                d="M50.536 52.886c2.23-4.008 2.224-8.661-3.725-15.368a18.047 18.047 0 0 0-9.239 4.982c9.09 1.858 12.156 5.797 12.964 10.386z"
                fill={color}/>
            <path
                d="M48.822 53.708c-2.841-3.469-6.31-6.145-16.076-2.395a17.978 17.978 0 0 0 .56 9.805c5.741-7.177 10.882-8.883 15.516-7.41z"
                fill={color}/>
            <path
                d="M47.266 73.014c-4.591-10.428-1.952-14.442 1.424-17.655-4.82-.071-8.944 2.831-11.984 11.651a18.056 18.056 0 0 0 10.56 6.004z"
                fill={color}/>
            <path
                d="M64.054 67.001c-9.838-1.772-13.091-5.824-13.926-10.572-2.334 4.196-2.219 9.098 4.6 16.323a18.05 18.05 0 0 0 9.326-5.751z"
                fill={color}/>
            <path
                d="M67.127 48.48c-5.647 6.936-10.713 8.581-15.285 7.129 2.873 3.506 6.384 6.208 16.401 2.271a17.979 17.979 0 0 0-1.116-9.4z"
                fill={color}/>
            <g>
                <path
                    d="M51.973 53.957c4.684.07 8.71-2.672 11.723-10.918a18.062 18.062 0 0 0-9.786-5.527c3.869 9.536 1.306 13.36-1.937 16.445z"
                    fill={color}/>
            </g>
            <path
                d="M29.079 39.672a26.48 26.48 0 0 1 6.763-6.446 2.47 2.47 0 0 0-.14-.481l-4.799-11.398c-.43-1.021-1.423-1.216-2.207-.432l-11.711 11.71c-.784.784-.588 1.774.434 2.201l11.431 4.773c.073.031.152.05.229.073z"
                fill={color}/>
            <path
                d="M39.628 31.15a26.254 26.254 0 0 1 10.725-2.282c3.59 0 7.01.72 10.129 2.019l4.705-11.172c.43-1.021-.125-1.857-1.233-1.857H36.047c-1.108 0-1.663.835-1.233 1.857l4.814 11.435z"
                fill={color}/>
            <path
                d="M83.015 32.625l-11.711-11.71c-.783-.784-1.777-.589-2.206.432l-4.8 11.399c-.013.031-.019.065-.031.097a26.48 26.48 0 0 1 7.212 6.62l11.101-4.636c1.023-.428 1.218-1.418.435-2.202z"
                fill={color}/>
            <path
                d="M84.608 68.602l-11.544-.003a26.477 26.477 0 0 1-4.095 5.284v6.661c0 .79.647 1.437 1.437 1.437h14.202c.791 0 1.437-.647 1.437-1.437V70.039c0-.79-.647-1.437-1.437-1.437z"
                fill={color}/>
            <path
                d="M84.186 38.393l-10.58 4.419a26.226 26.226 0 0 1 3.105 12.413c0 3.441-.667 6.725-1.866 9.739l9.186.003a2.02 2.02 0 0 0 2.015-2.014V39.631c-.001-1.108-.838-1.665-1.86-1.238z"
                fill={color}/>
            <path
                d="M23.997 55.225c0-4.392 1.08-8.528 2.98-12.17l-11.162-4.662c-1.022-.427-1.859.13-1.859 1.238v23.296c0 1.108.907 2.015 2.015 2.016l9.886.004a26.242 26.242 0 0 1-1.86-9.722z"
                fill={color}/>
            <path
                d="M27.643 68.597H15.401a1.45 1.45 0 0 0-1.446 1.446v10.652a1.45 1.45 0 0 0 1.446 1.446h14.396a1.45 1.45 0 0 0 1.446-1.446v-7.329a26.447 26.447 0 0 1-3.6-4.769z"
                fill={color}/>
        </svg>
    );
}

export default Portal;